import { isPlatformBrowser, NgIf } from '@angular/common';
import { AfterContentChecked, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CommonComponent } from '../../common/common.component';
import { PopupComponent } from '../popup/popup.component';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
    standalone: true,
    imports: [NgIf, RouterLink, PopupComponent]
})
export class MobileMenuComponent extends CommonComponent implements OnInit, AfterContentChecked {
  modalIsOpen = false;
  formValue = '';
  isMobile = false;

  constructor(
    private authenticationService: AuthenticationService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    super(authenticationService);
  }

  ngOnInit(): void {
  }

  ngAfterContentChecked(): void {
    this.checkIfMobile();
  }

  checkIfMobile(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.innerWidth > 550 ? this.isMobile = false : this.isMobile = true;
    }
  }

  openPopup(): void {
    this.modalIsOpen = true;
  }

  closePopup(): void {
    this.modalIsOpen = false;
    this.formValue = 'accedi';
  }

}
